const errorBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5.03 3.97l7 7-1.06 1.06-7-7z"/></svg>',
};

export { errorBold as default };
